import { socket } from '@dpgradio/creative'

export default {
  namespaced: true,
  state() {
    return {
      socket: null,
    }
  },
  mutations: {
    SET_SOCKET(state, stationSocket) {
      state.socket = stationSocket
    },
  },
  actions: {
    subscribeToSocket({ dispatch, commit }, { station, isStaging }) {
      const socketHost = isStaging
        ? 'https://socket.stag.qmusic.be/api'
        : 'https://socket.qmusic.be/api'

      const stationSocket = socket.connect(station, socketHost)

      stationSocket
        .subscribe('app_button')
        .on('update', (data) => {
          if (isStaging && data.apiCallback) {
            data.apiCallback = data.apiCallback.replace('://api.', '://api.stag.')
          }
          dispatch('setSignUpMoment', data, { root: true })
        }, { backlog: 1 })

      commit('SET_SOCKET', stationSocket)
    },
  },
}
